export { default as Img200 } from './processed/200/Band-Of-Brothers-S1.jpg';
export { default as Img400 } from './processed/400/Band-Of-Brothers-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Band-Of-Brothers-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Band-Of-Brothers-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Band-Of-Brothers-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      64,
      191,
      64
    ],
    "_population": 0
  },
  "LightVibrant": {
    "_rgb": [
      236,
      226,
      206
    ],
    "_population": 838,
    "_hsl": [
      0.11111111111111101,
      0.4411764705882355,
      0.8666666666666667
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      12,
      4
    ],
    "_population": 204,
    "_hsl": [
      0.3333333333333333,
      0.5,
      0.03137254901960784
    ]
  },
  "Muted": {
    "_rgb": [
      132,
      132,
      108
    ],
    "_population": 2,
    "_hsl": [
      0.16666666666666666,
      0.10000000000000006,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      209,
      204,
      185
    ],
    "_population": 602,
    "_hsl": [
      0.13194444444444456,
      0.2068965517241379,
      0.7725490196078431
    ]
  },
  "DarkMuted": {
    "_rgb": [
      84,
      74,
      60
    ],
    "_population": 4,
    "_hsl": [
      0.09722222222222227,
      0.16666666666666666,
      0.2823529411764706
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Band-Of-Brothers-S1.js